var map = {
	"./BATAVIA/logo.png": "7f02",
	"./CORAM/logo.png": "26c5",
	"./COUNTRYSIDE/logo.png": "654a",
	"./Demo1/logo.png": "36c1",
	"./Demo2/logo.png": "0258",
	"./ELMWOOD/logo.png": "6e9d",
	"./JERSEY/logo.png": "c655",
	"./ORANGE/logo.png": "12cb",
	"./RABS/logo.png": "5655",
	"./RIVER_CITY/logo.png": "3be4",
	"./RVC/logo.png": "c2ab",
	"./SANTA_FE/logo.png": "8ab2",
	"./VISION_LANES/logo.png": "bae9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c562";